import React from 'react';
import { FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';

const TextArea = ({ value, onChange, editable, placeholder, maxLength }) => {
  return (
    <FormControl
      componentClass="textarea"
      value={value}
      onChange={onChange}
      disabled={!editable}
      placeholder={placeholder}
      maxLength={maxLength}
    />
  );
};

TextArea.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  editable: PropTypes.bool
};

TextArea.defaultProps = {
  value: '',
  placeholder: ''
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/form/TextArea.js